export default "__VITE_ASSET__B19UZMEw__"